import React, { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { Global } from '../../../Variables/Global';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { getDecodedToken } from '../../../utils/utils';
import axiosInstance from '../../../api/axiosConfig';

const Currency = () =>{
     
    const [currency, setCurrency] = useState([]);

    const columns = [
        {
            name: '#',
            selector: row => row.currencyId,
            width:"60px"
        },
        {
            name: 'Currency Name',
            selector: row => row.currencyName,
        },
        {
            name: 'Currency Suffix',
            selector: row => row.currencySuffix,
        },
        {
            name: 'Options',
            width:"170px",
            selector: row => {
                return (
                    <>
                       
                        {permissions.editCurrency == true && (
                            <Link to={"/Settings/Currency/" + row.currencyId} className="btn btn-outline-warning mr-3">
                                <FiEdit />
                            </Link>
                        )}
                        {/* <button type="button" className="btn btn-outline-danger">
                            <FiTrash2 />
                        </button> */}
                    </>
                )
            },
        },
    ];

    const GetCurrency = () => {
        var config = {
            method: 'get',
            url: "Currency/GetCurrencies",
            headers: {},
        };

        axiosInstance(config)
            .then(function (response) {
                setCurrency(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const [permissions, setPermissions] = useState([])
    useEffect(() => {
        const decodedToken = getDecodedToken();
        const pJoin = JSON.stringify(JSON.parse(decodedToken.pJoin));
        var x = JSON.parse(pJoin);
        setPermissions(() => x);
        document.title = "Currencies";
        GetCurrency();
    }, [])
    return (
        <>
         {permissions.viewCurrency == false ? (
                <>
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h1>You Have No Permission</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="page-title-box">
                                <h4>Currency</h4>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="#">Mercator</a></li>
                                    <li className="breadcrumb-item active">Currency</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-12 col-md-6'>
                                        <h4 className="card-title">List Currency</h4>
                                        </div>
                                        <div className='col-12 col-md-6 text-right'>
                                            {permissions.addCurrency == true && (
                                                <Link to="/Settings/Currency/0" className="btn btn-primary">Add Currency</Link>
                                            )}
                                        </div>
                                    </div>
                                    
                                    <DataTable
                                        columns={columns}
                                        data={currency}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
            )}
        </>
    )
}
export default Currency